export default "__VITE_ASSET__BNvNaRgi__"